"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_abstract_path_1 = require("@comunica/actor-abstract-path");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica Path Link Query Operation Actor.
 */


var ActorQueryOperationPathLink =
/*#__PURE__*/
function (_actor_abstract_path_) {
  _inherits(ActorQueryOperationPathLink, _actor_abstract_path_);

  function ActorQueryOperationPathLink(args) {
    _classCallCheck(this, ActorQueryOperationPathLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationPathLink).call(this, args, sparqlalgebrajs_1.Algebra.types.LINK));
  }

  _createClass(ActorQueryOperationPathLink, [{
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(path, context) {
        var predicate, operation;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                predicate = path.predicate;
                operation = actor_abstract_path_1.ActorAbstractPath.FACTORY.createPattern(path.subject, predicate.iri, path.object, path.graph);
                return _context.abrupt("return", this.mediatorQueryOperation.mediate({
                  operation: operation,
                  context: context
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function runOperation(_x, _x2) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationPathLink;
}(actor_abstract_path_1.ActorAbstractPath);

exports.ActorQueryOperationPathLink = ActorQueryOperationPathLink;